<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <svg width="36" height="36" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#1e293b"/>
          <path d="M8 10h10M8 16h7M8 22h10" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
          <circle cx="23" cy="22" r="4" fill="white" fill-opacity="0.2" stroke="white" stroke-width="1.5"/>
          <path d="M21.5 22l1 1 2-2" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="logo-text">FormIQ</span>
      </div>

      <div class="login-card__divider"></div>

      <h1 class="login-card__title">Test-Login</h1>
      <p class="login-card__subtitle">
        Nutzen Sie einen der Demo-Accounts, um die Showcase-Umgebung zu erkunden.
      </p>

      <form class="login-form" @submit.prevent="handleLogin">
        <div class="form-group">
          <label class="form-label">Benutzername</label>
          <input
            v-model="username"
            type="text"
            class="form-input"
            placeholder="z. B. demo"
            autocomplete="username"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Passwort</label>
          <input
            v-model="password"
            type="password"
            class="form-input"
            placeholder="••••••••"
            autocomplete="current-password"
          />
        </div>

        <div v-if="errorMsg" class="login-error">
          ⚠️ {{ errorMsg }}
        </div>

        <button type="submit" class="login-btn" :disabled="loading">
          <span v-if="loading">Anmeldung läuft…</span>
          <span v-else>Anmelden →</span>
        </button>
      </form>
      <button class="back-link" @click="goBack">← Zurück zur Startseite</button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { authStore } from '../store/auth';

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter();
    const username = ref('');
    const password = ref('');
    const errorMsg = ref('');
    const loading = ref(false);

    const hints = [
      // { user: 'demo', pass: 'demo123' },
      // { user: 'test', pass: 'test123' },
      // { user: 'admin', pass: 'admin123' },
    ];

    const msgHints = [
      // { user: 'franz.boehmann@msg.group', pass: 'msg2025', name: 'Franz Boehmann' },
      // { user: 'jan.engelke@msg.group',    pass: 'msg2025', name: 'Jan Engelke' },
      // { user: 'sebastian.jensch@msg.group', pass: 'msg2025', name: 'Sebastian Jensch' },
    ];

    const fillCredentials = (acc) => {
      username.value = acc.user;
      password.value = acc.pass;
      errorMsg.value = '';
    };

    const handleLogin = async () => {
      errorMsg.value = '';
      if (!username.value || !password.value) {
        errorMsg.value = 'Bitte geben Sie Benutzername und Passwort ein.';
        return;
      }
      loading.value = true;
      const ok = await authStore.login(username.value.trim().toLowerCase(), password.value);
      loading.value = false;
      if (ok) {
        router.push('/dashboard');
      } else {
        errorMsg.value = 'Ungültige Anmeldedaten. Bitte probieren Sie einen Demo-Account.';
      }
    };

    const goBack = () => router.push('/');

    return { username, password, errorMsg, loading, hints, msgHints, handleLogin, fillCredentials, goBack };
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  padding: 24px;
}

.login-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 44px 40px;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
}

/* Logo */
.login-card__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 800;
}
.logo-text { color: #0f172a; }

.login-card__divider {
  height: 1px;
  background: #e2e8f0;
  margin: 2px 0;
}

/* Title */
.login-card__title {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.login-card__subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: -8px;
  line-height: 1.5;
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.form-input {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 11px 14px;
  font-size: 15px;
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-family: inherit;
}
.form-input::placeholder { color: #94a3b8; }
.form-input:focus {
  border-color: #1e293b;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(30, 41, 59, 0.08);
}

/* Error */
.login-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
}

/* Login button */
.login-btn {
  background: #1e293b;
  color: #fff;
  border: none;
  padding: 13px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  margin-top: 4px;
}
.login-btn:hover:not(:disabled) {
  background: #0f172a;
  transform: translateY(-1px);
}
.login-btn:disabled { opacity: 0.45; cursor: not-allowed; }

/* Demo hints */
.login-hints {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hints-title {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.hints-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.hint-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  font-size: 13px;
}
.hint-item:hover {
  border-color: #1e293b;
  background: #f8fafc;
}
.hint-user { color: #1e293b; font-weight: 700; }
.hint-pass { color: #94a3b8; font-family: monospace; font-size: 13px; flex-shrink: 0; }

.hints-title--msg {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid #e2e8f0;
}

.hint-item--msg { align-items: center; }

.hint-msg-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.hint-name {
  color: #1e293b;
  font-weight: 700;
  font-size: 13px;
}

.hint-email {
  color: #64748b;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Back link */
.back-link {
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 13px;
  cursor: pointer;
  text-align: center;
  padding: 4px;
  transition: color 0.2s;
}
.back-link:hover { color: #475569; }
</style>
